import React from 'react';
import { Box } from '@mui/material';
import Chart from 'react-apexcharts';

const BaseChart = ({
    options,
    series,
    primaryGranularity,
    chartHeight,
    chartID,
    chartProps = {},
    chartKey = '',
}) => {

    return (
        <Box sx={{ position: 'relative' }}>
            <Box>
                <Chart
                    id={primaryGranularity === 'raw' ? "hideAlternateLabel" : 'donthide'}
                    options={options}
                    series={series}
                    type="line"
                    height={chartHeight}
                    key={chartKey}
                    {...chartProps}
                />
            </Box>
        </Box>
    );
};

export default BaseChart;
